import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Bestätigungsdialog zum Beenden einer Aufnahme.
 */
function StopDialog({ open, measurementsCount, onConfirm, onCancel }) {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <div className="edit-overlay" onClick={onCancel}>
      <div className="edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="edit-header">
          <h3>{t('dialog.stop.title')}</h3>
          <button className="btn-close" onClick={onCancel} type="button">×</button>
        </div>
        <div className="edit-content">
          <p style={{ fontSize: '1rem', color: '#374151', lineHeight: '1.6' }}>
            {t('dialog.stop.confirm')}
          </p>
          <div className="edit-info">
            <div><strong>{t('dialog.stop.measurements_label')}</strong> {measurementsCount}</div>
            <div style={{ marginTop: '8px', fontSize: '0.9rem', color: '#6b7280' }}>
              {t('dialog.stop.saved_hint')}
            </div>
          </div>
        </div>
        <div className="edit-actions">
          <button className="btn btn-primary" onClick={onConfirm} type="button">
            {t('dialog.stop.button')}
          </button>
          <button className="btn btn-secondary" onClick={onCancel} type="button">
            {t('dialog.cancel')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default StopDialog;
